import { useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from "@material-ui/core";
import { ListSelector, ListSelectorItem } from "./list-selector";
import { Button } from "../input/components/button";

type Props = {
  items: Array<ListSelectorItem>;
  open: boolean;
  title: string;
  multi: boolean;
  loading?: boolean;
  withSearch?: boolean;
  onClose: () => void;
  onSelected: (selected: string[]) => void;
};

export function ListSelectorModal(props: Props) {
  const [selected, setSelected] = useState<string[]>([]);

  const handleChange = (value: string[]) => {
    if (props.multi) {
      setSelected(value);
    } else {
      props.onSelected(value);
    }
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth
      scroll="paper"
      onClose={props.onClose}
    >
      <DialogTitle style={{ paddingTop: "24px", paddingBottom: "24px" }}>
        <Typography variant="h3">{props.title}</Typography>
      </DialogTitle>

      <DialogContent>
        {props.loading && <Typography>Loading...</Typography>}

        {!props.loading && (
          <ListSelector
            items={props.items}
            value={selected}
            onChange={handleChange}
            multi={props.multi}
            withSearch={props.withSearch}
          />
        )}
      </DialogContent>

      <DialogActions>
        <Button variant="text" color="default" onClick={props.onClose}>
          Cancel
        </Button>

        {props.multi && (
          <Button
            variant="contained"
            color="primary"
            onClick={() => props.onSelected(selected)}
            disabled={selected.length === 0}
          >
            OK
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
